import React, { useState } from "react";
import { Button, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";
import "./AdvocateDetails.css";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { emailPreFix, phonePreFix } from "../../pages/About";
import EditAdvocate from "../layout/EditAdvocate";
import PublicModal from "../layout/Reminders/PublicModal";

const AdvocateDetails = (props) => {
  const [editAdvocateOpen, setEditAdvocateOpen] = useState(false);
  const [remindersModal, setRemindersModal] = useState(false);
  return (
    <div className="AthleteDetailsBackground cu-profile">
      <div className="AthleteDetailsBannerBar"></div>
      <div className="AthleteSearchBanner">
        <h1>Profile</h1>
      </div>
      <div className="AthleteDetailsButtonContainer">
        <Button
          labelPosition="left"
          color="black"
          name="advocatesButton"
          icon="bell"
          content="Reminders"
          onClick={() => setRemindersModal(!remindersModal)}
        />
        <PublicModal
          id={props.id}
          open={remindersModal}
          close={() => setRemindersModal(false)}
        />
        <Link to={`/admin/${props.advocate.id}/events`}>
          <Button icon labelPosition="left" color="blue">
            <Icon name="list" />
            Events
          </Button>
        </Link>
        <Link to={`/admin/${props.advocate.id}/a/wikis`}>
          <Button
            icon="wikipedia w"
            labelPosition="left"
            color="grey"
            name="editedButton"
            content="Wiki & Info"
          />
        </Link>
        <Button
          icon
          labelPosition="left"
          color="green"
          onClick={() => {
            setEditAdvocateOpen(true);
          }}
        >
          <Icon name="user secret" />
          Edit Profile
        </Button>
      </div>

      <div className="AthleteDetailsGroupContainer">
        <div className="AthleteDetailsThumbnailContainer">
          <img
            src={
              props.advocate
                ? props.advocate.thumbnailUrl
                : "https://via.placeholder.com/200x200.png/e6e6e6/000000?Text=200x200"
            }
            alt="Athlete Thumbnail"
          />
        </div>
        {/* <AthleteVideoList id={id} /> */}

        <div className="AthleteDetailsInfoContainer set-margin">
          <div className="AthleteDetailsPersonalContainer single">
            <div className="AthleteDetailsPersonalContainerTitle">
              <h3>Your Profile</h3>
            </div>
            <div className="AthleteDetailsPersonalContainerRow">
              <div className="AthleteDetailsPersonalContainerRowTitle">
                <p>Name: </p>
              </div>
              <p>
                {props.advocate ? props.advocate.name : "Name Will Be Here"}
              </p>
            </div>
            <div className="AthleteDetailsPersonalContainerRow">
              <div className="AthleteDetailsPersonalContainerRowTitle">
                <p>Title: </p>
              </div>
              <p>
                {props.advocate ? props.advocate.title : "Title Will Be Here"}
              </p>
            </div>
          </div>
          <div className="AthleteDetailsPersonalContainer of-social">
            <div className="AthleteDetailsPersonalContainerTitle">
              <h3>Socials</h3>
            </div>
            {props.advocate.facebook && (
              <div className="AthleteDetailsPersonalContainerRow">
                <div className="AthleteDetailsPersonalContainerRowTitle">
                  <p
                    href={props.advocate.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={require("../../images/facebook.svg").default}
                      alt="Facebook"
                    />
                    :
                  </p>
                </div>
                <p>{props.advocate.facebook}</p>
              </div>
            )}
            {props.advocate.twitter && (
              <div className="AthleteDetailsPersonalContainerRow">
                <div className="AthleteDetailsPersonalContainerRowTitle">
                  <p
                    href={props.advocate.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={require("../../images/twitter.svg").default}
                      alt="twitter"
                    />
                    :
                  </p>
                </div>
                <p>{props.advocate.twitter}</p>
              </div>
            )}
            {props.advocate.instagram && (
              <div className="AthleteDetailsPersonalContainerRow">
                <div className="AthleteDetailsPersonalContainerRowTitle">
                  <p
                    href={props.advocate.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={require("../../images/instagram.svg").default}
                      alt="instagram"
                    />
                    :
                  </p>
                </div>
                <p>{props.advocate.instagram}</p>
              </div>
            )}
            {props.advocate.linkedin && (
              <div className="AthleteDetailsPersonalContainerRow">
                <div className="AthleteDetailsPersonalContainerRowTitle">
                  <p
                    href={props.advocate.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={require("../../images/linkedIn.svg").default}
                      alt="linkedin"
                    />
                    :
                  </p>
                </div>
                <p>{props.advocate.linkedin}</p>
              </div>
            )}
            {props.advocate.email && (
              <div className="AthleteDetailsPersonalContainerRow">
                <div className="AthleteDetailsPersonalContainerRowTitle">
                  <p>Email :</p>
                </div>
                <p>
                  <a href={emailPreFix + props.advocate.email}>
                    {props.advocate.email}
                  </a>
                </p>
              </div>
            )}
            {props.advocate.phone && (
              <div className="AthleteDetailsPersonalContainerRow">
                <div className="AthleteDetailsPersonalContainerRowTitle">
                  <p>Phone :</p>
                </div>
                <p>
                  <a
                    href={phonePreFix + props.advocate.phone}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {props.advocate.phone}
                  </a>
                </p>
              </div>
            )}
          </div>
        </div>
        <div className="AthleteDetailsInfoContainer single">
          <div className="AthleteDetailsPersonalContainer single pb-10">
            <div className="AthleteDetailsPersonalContainerTitle">
              <h3>About</h3>
            </div>
          </div>
          <div className="AthleteDetailsPersonalContainerRow">
            <p>
              {props.advocate ? props.advocate.about : "About Will Be Here"}
            </p>
          </div>
        </div>
      </div>
      <EditAdvocate
        open={editAdvocateOpen}
        onClose={() => {
          setEditAdvocateOpen(false);
        }}
        editData={props.advocate}
      />
    </div>
  );
};
const mapStateToProps = (state, ownProps) => {
  let advocate;
  const advocateId = ownProps.id;

  if (state.firestore.data.advocates && advocateId) {
    advocate = state.firestore.data.advocates[advocateId];
  }

  return {
    advocate,
    advocates: state.firestore.ordered.advocates,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    { collection: "advocates" },
    { collection: "wikiPerson" },
    { collection: "wiki" },
  ])
)(AdvocateDetails);
